import { ref } from 'vue';
import Request from '@/services/request';
import { SELLER_COMMISSION_CAMPAIGN_DETAIL } from '@/utils/enum/endpoints';

const Req = new Request();

export default function useCampaignDetail() {
  const data = ref(null);
  const error = ref(null);
  const isLoading = ref(false);

  const fetchData = async (campaignId) => {
    isLoading.value = true;

    try {
      const response = await Req.get(
        SELLER_COMMISSION_CAMPAIGN_DETAIL.replace('{campaignId}', campaignId),
        null,
        {
          baseURL: '/sellerofficeapi/rest',
          headers: { Accept: 'application/json' },
        },
      );

      if (!response.status || response.status !== 200) {
        throw new Error('Network response was not OK');
      }

      data.value = response.data;
      error.value = null;
    } catch (err) {
      error.value = err || null;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    data,
    error,
    isLoading,
    fetchData,
  };
}
